import React from 'react';
import { Box } from '@mui/material';
import { NumberRangeAggregation as NumberRangeAggregationType } from '../../redux/types';
import { FormattedAggregatedResultNumberRange } from './FormattedResult';

type Props = {
  data: NumberRangeAggregationType;
}

const NumberRangeAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
      Object.entries(data.payload.correct).map((
        [key, val],
      ) => (
        <FormattedAggregatedResultNumberRange
          key={key}
          reviewCount={data.payload.reviewCount}
          text={key}
          total={val}
          fontWeight={500}
        />
      ))
    }
    {
      Object.entries(data.payload.acceptable).map((
        [key, val],
      ) => (
        <FormattedAggregatedResultNumberRange
          key={key}
          reviewCount={data.payload.reviewCount}
          text={key}
          total={val}
        />
      ))
    }
    {
      Object.entries(data.payload.outlier).map((
        [key, val],
      ) => (
        <FormattedAggregatedResultNumberRange
          key={key}
          reviewCount={data.payload.reviewCount}
          text={key}
          total={val}
        />
      ))
    }
  </Box>
);

export default NumberRangeAggregation;
